
import * as selfFiling from './selfFiling'
import * as home from './home'
import * as caseProgress from './caseProgress'
import * as documentService from './documentService'
export default {
  selfFiling,
  home,
  caseProgress,
  documentService,
}



// WEBPACK FOOTER //
// ./src/api/index.js